@import 'vars';

$icon-size-desktop: 15px;
$icon-size-softphone: 15px;

.contact-directory-icon {
  &__tooltip {
    padding-block: 5px;

    &__header {
      font-size: $font-size-small;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    width: $icon-size-desktop;
    height: $icon-size-desktop;

    &--softphone {
      width: $icon-size-softphone;
      height: $icon-size-softphone;
    }
  }
}
